import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import throttle from 'lodash/throttle';
import MediaQuery from 'react-responsive';
import { trans } from '@spotahome/bff/client';
import { Button } from '@spotahome/ui-library';
import '@spotahome/ui-library/lib/components/Button.css';

import SortBy from '@search/components/SortBy';

import { sticky } from '@common/utils/sticky';
import {
  MQ_MOBILE_MIN_WIDTH,
  MQ_SMALL_MOBILE_MAX_WIDTH
} from '@common/constants';

import AlertButton from '@search/components/AlertButton';
import { Consumer } from '@search/IsUserLoggedContext';

import './FilterHeader.scss';

const STICKY_TO_SELECTOR = '.search-scroll';

class FiltersHeader extends Component {
  static propTypes = {
    totalResults: PropTypes.number.isRequired,
    maxTotalResults: PropTypes.number.isRequired,
    handleFiltersToggle: PropTypes.func.isRequired,
    areaSlug: PropTypes.string.isRequired,
    expandedFilters: PropTypes.bool,
    orderBy: PropTypes.string,
    handleSortChange: PropTypes.func,
    filters: PropTypes.shape({
      'bathrooms[]': PropTypes.arrayOf(PropTypes.string),
      bed: PropTypes.string,
      budget: PropTypes.string,
      'features[]': PropTypes.arrayOf(PropTypes.string),
      'move-in': PropTypes.string,
      'move-out': PropTypes.string,
      poi: PropTypes.string,
      'topology[]': PropTypes.arrayOf(PropTypes.string),
      'type[]': PropTypes.arrayOf(PropTypes.string)
    }).isRequired
  };

  static defaultProps = {
    expandedFilters: true,
    totalResults: 0
  };

  constructor(props) {
    super(props);

    this.headerElementRef = React.createRef();
    this.filterHeaderResultsRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.expandedFilters) {
      const wrapper = document.querySelector(STICKY_TO_SELECTOR);
      const { stick, recalculate } = sticky(
        this.headerElementRef.current,
        wrapper
      );
  
      recalculate();
      wrapper.addEventListener('scroll', throttle(stick, 25));
      window.addEventListener('resize', throttle(recalculate, 50));
    }
  }

  getPercentage = () =>
    this.props.maxTotalResults
      ? this.props.totalResults * 100 / this.props.maxTotalResults
      : 100;

  renderResultsCandyBar = () => (
    <div className="filter-header__candy-bar">
      <div
        className="filter-header__candy-bar-results"
        style={{ width: `${this.getPercentage()}%` }}
      />
    </div>
  );

  render() {
    const { expandedFilters } = this.props;
    const closeFiltersText = trans('search.filters.view_close_filters', {
      nResults: this.props.totalResults
    });
    const buttonText = trans('search.filter_header.more_filters');
    const buttonTextShort = trans('search.filter_header.more_filters.short');

    const classes = classNames('search-filter-header', {
      'search-filter-header--expanded': expandedFilters
    });

    return (
      <div className={classes}>
        <div className="filter-header" ref={this.headerElementRef}>
          <div className="filter-header__results">
            <SortBy
              handleSortByChange={this.props.handleSortChange}
              orderBy={this.props.orderBy}
            />
            <div className="filter-header__results-button-row">
              <Consumer>
                {({ allCities, isUserLogged }) => (
                  <AlertButton
                    cityId={this.props.areaSlug}
                    filters={this.props.filters}
                    allCities={allCities}
                    isUserLogged={isUserLogged}
                  />
                )}
              </Consumer>
              <Button
                className="filter-header__results-button ga-search-form-more-filters"
                onClick={this.props.handleFiltersToggle}
                data-cy="more-filters-button"
              >
                <MediaQuery minWidth={MQ_MOBILE_MIN_WIDTH}>
                  {expandedFilters ? closeFiltersText : buttonText}
                </MediaQuery>
                <MediaQuery maxWidth={MQ_SMALL_MOBILE_MAX_WIDTH}>
                  {expandedFilters ? closeFiltersText : buttonTextShort}
                </MediaQuery>
              </Button>
            </div>
          </div>
        </div>
        {this.renderResultsCandyBar()}
      </div>
    );
  }
}

export default FiltersHeader;
